import {Component, Inject, Input, OnInit, EventEmitter,Output} from 'ng-metadata/core';
import {FullViewModuleLoaderService} from "../search/fullView/fullViewModuleLoader.service"
import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import { SendEmailService } from '../search/actions/sendEmailAction/sendEmail.service';

const maxTimeout = 5;
const msTimeout = 100;

@Component({
    selector: 'prm-email-template',
    template: '<prm-change-lang ng-if="$ctrl.$state.current.name === STATE_NAMES.EMAIL_TEMPLATE" style="display: none"></prm-change-lang><prm-static ng-if="$ctrl.items" section="email" [parent-ctrl]="$ctrl" (template-included-event)="$ctrl.handleEmailTemplate()" style="max-width: 100%; min-width: 100%"></prm-static>'
})

export class PrmEmailTemplate implements OnInit{

    @Input() public items: any[];
    @Input() public note: string;
    private fullViewLoaded: boolean = false;
    private delayedItems: any[] = [];
    private tmpItems: any[];
    private records: string;
    private intervalCounter: number;
    private _missingItemInEmail: boolean = false;
    @Output() emailTemplateItemsEvent = new EventEmitter();

    constructor(@Inject('$stateParams') private $stateParams:angular.ui.IStateParamsService,
                private fullViewModuleLoaderService: FullViewModuleLoaderService,
                private sendEmailService: SendEmailService,
                @Inject('$state') public $state: ng.ui.IStateService,
                @Inject('$interval') private $interval: ng.IIntervalService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$location') private $location: angular.ILocationService) {
    }

    ngOnInit() {
        if(this.isStudioExample()){
            if (!this.note && this.note !== '') {
                this.note = 'This is a preview note';
            }
            this.fullViewModuleLoaderService.loadFullViewModule().then(() => {
                if (!this.items || this.items === []) {
                    if (this.$stateParams['items'] && this.$stateParams['items'] !== []) {
                        this.items = this.$stateParams['items'];
                    } else {
                        this.items = [
                            {
                            "enrichment": {
                                "virtualBrowseObject": {
                                    "callNumber": "",
                                    "isVirtualBrowseEnabled": false,
                                    "callNumberBrowseField": "browse_callnumber"
                                }
                            },
                            "delivery": {
                                "availabilityLinks": [
                                    "detailsGetit1"
                                ],
                                "physicalItemTextCodes": "",
                                "displayLocation": true,
                                "almaInstitutionsList": [
                                    {
                                        "inst": "",
                                        "availabilityStatus": "unavailable",
                                        "getitLink": [
                                            {
                                                "isLinktoOnline": false,
                                                "displayText": "Almagetit",
                                                "hyperlinkText": "",
                                                "link": ""
                                            }
                                        ]
                                    }
                                ],
                                "availabilityLinksUrl": [
                                    ""
                                ],
                                "link": [
                                    {
                                        "displayLabel": "thumbnail",
                                        "hyperlinkText": "",
                                        "inst4opac": "INST",
                                        "linkURL": "",
                                        "linkType": "",
                                        "@id": "_:0"
                                    },
                                    {
                                        "displayLabel": "thumbnail",
                                        "linkURL": "",
                                        "linkType": "",
                                        "@id": "_:1"
                                    }
                                ],
                                "availability": [
                                    "does_not_exist_in_my_institution_unavailable"
                                ],
                                "additionalLocations": true,
                                "displayedAvailability": "does_not_exist_in_my_institution_unavailable",
                                "holding": [
                                    {
                                        "matchForHoldings": [
                                            {
                                                "holdingRecord": "",
                                                "matchOn": "MainLocation"
                                            }
                                        ],
                                        "subLocationCode": "SUB_CODE",
                                        "ilsApiId": "",
                                        "libraryCode": "Somewhere",
                                        "isValidUser": false,
                                        "mainLocation": "Somewhere",
                                        "callNumber": "CallNumber",
                                        "adaptorid": "adaptorId",
                                        "organization": "INST",
                                        "holdingURL": "OVP",
                                        "@id": "_:0",
                                        "availabilityStatus": "unavailable",
                                        "subLocation": "Main Library",
                                        "holdId": ""
                                    },
                                    {
                                        "matchForHoldings": [
                                            {
                                                "holdingRecord": "",
                                                "matchOn": "MainLocation"
                                            }
                                        ],
                                        "subLocationCode": "SUB_CODE",
                                        "ilsApiId": "",
                                        "libraryCode": "Somewhere",
                                        "isValidUser": false,
                                        "mainLocation": "Somewhere",
                                        "callNumber": "CallNumber",
                                        "adaptorid": "adaptorId",
                                        "organization": "INST",
                                        "holdingURL": "OVP",
                                        "@id": "_:1",
                                        "availabilityStatus": "unavailable",
                                        "subLocation": "Main Library",
                                        "holdId": ""
                                    }
                                ],
                                "bestlocation": {
                                    "matchForHoldings": [
                                        {
                                            "holdingRecord": "",
                                            "matchOn": "MainLocation"
                                        }
                                    ],
                                    "mainLocation": "Somewhere",
                                    "subLocationCode": "SUB_CODE",
                                    "callNumber": "CallNumber",
                                    "organization": "INST",
                                    "libraryCode": "Somewhere",
                                    "@id": "_:0",
                                    "availabilityStatus": "unavailable",
                                    "subLocation": "Main Library",
                                    "holdId": "",
                                    "isValidUser": false
                                },
                                "deliveryCategory": [
                                    "Alma-P"
                                ],
                                "serviceMode": [
                                    "activate"
                                ],
                                "feDisplayOtherLocations": true,
                                "GetIt1": [
                                    {
                                        "links": [
                                            {
                                                "isLinktoOnline": false,
                                                "displayText": "Almagetit",
                                                "hyperlinkText": "",
                                                "getItTabText": "alma_tab1_notexistunavail",
                                                "link": "",
                                                "@id": "_:0"
                                            }
                                        ],
                                        "category": "Alma-P"
                                    }
                                ]
                            },
                            "@rta_link": "",
                            "context": "L",
                            "lang3": "eng",
                            "pnx": {
                                "delivery": {
                                    "institution": [
                                        "INST"
                                    ],
                                    "delcategory": [
                                        "Alma-P"
                                    ]
                                },
                                "search": {
                                    "recordid": [
                                        "exampleRecordId"
                                    ],
                                    "sourceid": [
                                        "example"
                                    ],
                                    "general": [
                                        ""
                                    ],
                                    "creationdate": [
                                        "2019"
                                    ],
                                    "creator": [
                                        "Suggested by ExLibris Primo"
                                    ],
                                    "enddate": [
                                        "20191231"
                                    ],
                                    "contributor": [
                                        "Suggested by ExLibris Primo"
                                    ],
                                    "scope": [
                                        "example",
                                        "INST"
                                    ],
                                    "rsrctype": [
                                        "book"
                                    ],
                                    "title": [
                                        "How to customize Primo Email/Primo template via Primo Studio"
                                    ],
                                    "startdate": [
                                        "2019101"
                                    ],
                                    "addsrcrecordid": [
                                        "000000123"
                                    ]
                                },
                                "display": {
                                    "creationdate": [
                                        "2019"
                                    ],
                                    "creator": [
                                        "Suggested by ExLibris Primo"
                                    ],
                                    "availinstitution": [
                                        "$$IINST$$Sunavailable"
                                    ],
                                    "contributor": [
                                        "Suggested by ExLibris Primo"
                                    ],
                                    "format": [
                                        "HTML"
                                    ],
                                    "publisher": [
                                        "Exlibris Primo"
                                    ],
                                    "availlibrary": [
                                        ""
                                    ],
                                    "language": [
                                        "eng"
                                    ],
                                    "availpnx": [
                                        "unavailable"
                                    ],
                                    "source": [
                                        "Documentation Center"
                                    ],
                                    "title": [
                                        "How to customize Primo Email/Primo template via Primo Studio"
                                    ],
                                    "type": [
                                        "article"
                                    ]
                                },
                                "links": {
                                    "thumbnail": [
                                        "$$Tgoogle_thumb"
                                    ],
                                    "uri": [
                                        ""
                                    ],
                                    "linktouc": [
                                        ""
                                    ]
                                },
                                "ranking": {
                                    "booster2": [
                                        "1"
                                    ],
                                    "booster1": [
                                        "1"
                                    ]
                                },
                                "control": {
                                    "recordid": [
                                        "exampleRecordId"
                                    ],
                                    "sourceid": [
                                        "example"
                                    ],
                                    "almaid": [
                                        "INST:2112112112111021",
                                        "INST/2112112112111021"
                                    ],
                                    "almaidthumb": [
                                        "INST/2112112112111021"
                                    ],
                                    "originalsourceid": [
                                        "INST"
                                    ],
                                    "sourceformat": [
                                        "MARC21"
                                    ],
                                    "sourcerecordid": [
                                        "2112112112111021"
                                    ],
                                    "sourcesystem": [
                                        "Alma"
                                    ]
                                },
                                "addata": {
                                    "date": [
                                        "2019"
                                    ],
                                    "aulast": [
                                        "Primo"
                                    ],
                                    "cop": [
                                        "Exlibris Primo"
                                    ],
                                    "format": [
                                        "article"
                                    ],
                                    "ristype": [
                                        "ARTICLE"
                                    ],
                                    "mis1": [
                                        "2112112112111021"
                                    ],
                                    "oclcid": [
                                        "88888888"
                                    ],
                                    "aufirst": [
                                        "Suggested",
                                    ],
                                    "addau": [
                                        "Suggested by ExLibris Primo"
                                    ],
                                    "au": [
                                        "Suggested by ExLibris Primo"
                                    ],
                                    "genre": [
                                        "article"
                                    ],
                                    "btitle": [
                                        "How to customize Primo Email/Primo template via Primo Studio"
                                    ],
                                    "risdate": [
                                        "2019"
                                    ],
                                    "pub": [
                                        "ExLibris Primo"
                                    ]
                                },
                                "sort": {
                                    "creationdate": [
                                        "2019"
                                    ],
                                    "author": [
                                        "Suggested by ExLibris Primo"
                                    ],
                                    "title": [
                                        "How to customize Primo Email/Primo template via Primo Studio"
                                    ]
                                },
                                "frbr": {
                                    "t": [
                                        1
                                    ],
                                    "k1": [
                                        "$$KSuggested by ExLibris Primo$$AA"
                                    ],
                                    "k3": [
                                        "$$KHow to customize Primo Email/Primo template via Primo Studio$$AT"
                                    ]
                                },
                                "dedup": {
                                    "c3": [
                                        "How to customize Primo Email/Primo template via Primo Studio"
                                    ],
                                    "f6": [
                                        "2019"
                                    ],
                                    "c4": [
                                        "2019"
                                    ],
                                    "f7": [
                                        "How to customize Primo Email/Primo template via Primo Studio"
                                    ],
                                    "c5": [
                                        "123456789001021"
                                    ],
                                    "f8": [
                                        "mnu"
                                    ],
                                    "f9": [
                                        "version"
                                    ],
                                    "t": [
                                        1
                                    ],
                                    "f10": [
                                        "Exlibris Primo"
                                    ],
                                    "f20": [
                                        "987654321001021"
                                    ],
                                    "f11": [
                                        "suggested by exlibris primo"
                                    ],
                                    "f5": [
                                        "example"
                                    ]
                                },
                                "facets": {
                                    "frbrtype": [
                                        "6"
                                    ],
                                    "creatorcontrib": [
                                        "Doe, John",
                                        "Exlibris Primo"
                                    ],
                                    "creationdate": [
                                        "2019"
                                    ],
                                    "newrecords": [
                                        "20190107_529"
                                    ],
                                    "library": [
                                        "MAIN"
                                    ],
                                    "atoz": [
                                        "S"
                                    ],
                                    "frbrgroupid": [
                                        "5555555"
                                    ],
                                    "rsrctype": [
                                        "books"
                                    ],
                                    "language": [
                                        "eng"
                                    ],
                                    "prefilter": [
                                        "books"
                                    ]
                                },
                                "browse": {
                                    "institution": [
                                        "INST"
                                    ],
                                    "author": [
                                        "$$DDoe, John$$EDoe, John",
                                        "$$DSuggested by ExLibris Primo$$ESuggested by ExLibris Primo"
                                    ],
                                    "callnumber": [
                                        "$$IINST$$DCall Number$$ECall Number$$T0"
                                    ],
                                    "title": [
                                        "$$DExample$$EExample"
                                    ]
                                }
                            },
                            "@id": "_0",
                            "beaconO22": "96"
                        },
                            {
                                "enrichment": {
                                    "virtualBrowseObject": {
                                        "callNumber": "",
                                        "isVirtualBrowseEnabled": false,
                                        "callNumberBrowseField": "browse_callnumber"
                                    }
                                },
                                "delivery": {
                                    "availabilityLinks": [
                                        "detailsGetit1"
                                    ],
                                    "physicalItemTextCodes": "",
                                    "displayLocation": true,
                                    "almaInstitutionsList": [
                                        {
                                            "inst": "INST",
                                            "availabilityStatus": "unavailable",
                                            "getitLink": [
                                                {
                                                    "isLinktoOnline": false,
                                                    "displayText": "Almagetit",
                                                    "hyperlinkText": "",
                                                    "link": ""
                                                }
                                            ]
                                        }
                                    ],
                                    "availabilityLinksUrl": [
                                        ""
                                    ],
                                    "link": [
                                        {
                                            "displayLabel": "thumbnail",
                                            "hyperlinkText": "",
                                            "inst4opac": "INST",
                                            "linkURL": "",
                                            "linkType": "",
                                            "@id": "_:0"
                                        }
                                    ],
                                    "availability": [
                                        "does_not_exist_in_my_institution_unavailable"
                                    ],
                                    "additionalLocations": true,
                                    "displayedAvailability": "does_not_exist_in_my_institution_unavailable",
                                    "holding": [
                                        {
                                            "matchForHoldings": [
                                                {
                                                    "holdingRecord": "",
                                                    "matchOn": "MainLocation"
                                                }
                                            ],
                                            "subLocationCode": "SUB_CODE",
                                            "ilsApiId": "",
                                            "libraryCode": "Somewhere",
                                            "isValidUser": false,
                                            "mainLocation": "Somewhere",
                                            "callNumber": "CallNumber",
                                            "adaptorid": "adaptorId",
                                            "organization": "INST",
                                            "holdingURL": "OVP",
                                            "@id": "_:0",
                                            "availabilityStatus": "unavailable",
                                            "subLocation": "Main Library",
                                            "holdId": ""
                                        }
                                    ],
                                    "bestlocation": {
                                        "matchForHoldings": [
                                            {
                                                "holdingRecord": "",
                                                "matchOn": "MainLocation"
                                            }
                                        ],
                                        "mainLocation": "Main Location",
                                        "subLocationCode": "SUB_CODE",
                                        "callNumber": "Other Call Number",
                                        "organization": "INST",
                                        "libraryCode": "MAIN",
                                        "@id": "_:0",
                                        "availabilityStatus": "unavailable",
                                        "subLocation": "Another Library",
                                        "holdId": "",
                                        "isValidUser": false
                                    },
                                    "deliveryCategory": [
                                        "Alma-P"
                                    ],
                                    "serviceMode": [
                                        "activate"
                                    ],
                                    "feDisplayOtherLocations": true,
                                    "GetIt1": [
                                        {
                                            "links": [
                                                {
                                                    "isLinktoOnline": false,
                                                    "displayText": "Almagetit",
                                                    "hyperlinkText": "",
                                                    "getItTabText": "alma_tab1_notexistunavail",
                                                    "link": "",
                                                    "@id": "_:0"
                                                }
                                            ],
                                            "category": "Alma-P"
                                        }
                                    ]
                                },
                                "@rta_link": "",
                                "context": "L",
                                "lang3": "eng",
                                "pnx": {
                                    "delivery": {
                                        "institution": [
                                            "INST"
                                        ],
                                        "delcategory": [
                                            "Alma-P"
                                        ]
                                    },
                                    "search": {
                                        "recordid": [
                                            "exampleRecordId"
                                        ],
                                        "sourceid": [
                                            "example"
                                        ],
                                        "general": [
                                            "ExLibris Primo"
                                        ],
                                        "creationdate": [
                                            "2019"
                                        ],
                                        "creator": [
                                            "It ain’t over…till you download"
                                        ],
                                        "enddate": [
                                            "20191231"
                                        ],
                                        "contributor": [
                                            "It ain’t over…till you download"
                                        ],
                                        "scope": [
                                            "example",
                                            "INST"
                                        ],
                                        "rsrctype": [
                                            "book"
                                        ],
                                        "title": [
                                            "Customization template should be downloaded and uploaded via your Primo Admin"
                                        ],
                                        "startdate": [
                                            "2019101"
                                        ],
                                        "addsrcrecordid": [
                                            "987654321001021"
                                        ]
                                    },
                                    "display": {
                                        "creationdate": [
                                            "2019"
                                        ],
                                        "creator": [
                                            "It ain’t over…till you download"
                                        ],
                                        "availinstitution": [
                                            "$$IINST$$Sunavailable"
                                        ],
                                        "contributor": [
                                            "It ain’t over…till you download"
                                        ],
                                        "format": [
                                            "HTML"
                                        ],
                                        "publisher": [
                                            "Exlibris Primo"
                                        ],
                                        "availlibrary": [
                                            "$$IINST$$LOTHER$$1ExLibris Primo$$2Other Call Number$$Sunavailable$$XINST$$YOTHER$$ZR111D$$P1",
                                        ],
                                        "language": [
                                            "eng"
                                        ],
                                        "availpnx": [
                                            "unavailable"
                                        ],
                                        "source": [
                                            "Documentation Center"
                                        ],
                                        "title": [
                                            "Customization template should be downloaded and uploaded via your Primo Admin"
                                        ],
                                        "type": [
                                            "article"
                                        ]
                                    },
                                    "links": {
                                        "thumbnail": [
                                            "$$Tgoogle_thumb"
                                        ],
                                        "uri": [
                                            ""
                                        ],
                                        "linktouc": [
                                            ""
                                        ]
                                    },
                                    "ranking": {
                                        "booster2": [
                                            "1"
                                        ],
                                        "booster1": [
                                            "1"
                                        ]
                                    },
                                    "control": {
                                        "recordid": [
                                            "exampleRecordId"
                                        ],
                                        "sourceid": [
                                            "example"
                                        ],
                                        "almaid": [
                                            "INST:2112112112001021",
                                            "INST/2112112112001021"
                                        ],
                                        "almaidthumb": [
                                            "INST/2112112112001021"
                                        ],
                                        "originalsourceid": [
                                            "INST"
                                        ],
                                        "sourceformat": [
                                            "MARC21"
                                        ],
                                        "sourcerecordid": [
                                            "2112112112001021"
                                        ],
                                        "sourcesystem": [
                                            "Alma"
                                        ]
                                    },
                                    "addata": {
                                        "date": [
                                            "2019"
                                        ],
                                        "aulast": [
                                            "Primo"
                                        ],
                                        "cop": [
                                            "ExLibris Primo"
                                        ],
                                        "format": [
                                            "article"
                                        ],
                                        "ristype": [
                                            "ARTICLE"
                                        ],
                                        "mis1": [
                                            "2112112112001021"
                                        ],
                                        "oclcid": [
                                            "88888888"
                                        ],
                                        "aufirst": [
                                            "Suggested",
                                        ],
                                        "addau": [
                                            "It ain’t over…till you download"
                                        ],
                                        "au": [
                                            "It ain’t over…till you download"
                                        ],
                                        "genre": [
                                            "article"
                                        ],
                                        "btitle": [
                                            "Customization template should be downloaded and uploaded via your Primo Admin"
                                        ],
                                        "risdate": [
                                            "2019"
                                        ],
                                        "pub": [
                                            "ExLibris Primo"
                                        ]
                                    },
                                    "sort": {
                                        "creationdate": [
                                            "2019"
                                        ],
                                        "author": [
                                            "It ain’t over…till you download"
                                        ],
                                        "title": [
                                            "Customization template should be downloaded and uploaded via your Primo Admin"
                                        ]
                                    },
                                    "frbr": {
                                        "t": [
                                            1
                                        ],
                                        "k1": [
                                            "$$KIt ain’t over…till you download$$AA"
                                        ],
                                        "k3": [
                                            "$$KCustomization template should be downloaded and uploaded via your Primo Admin$$AT"
                                        ]
                                    },
                                    "dedup": {
                                        "c3": [
                                            "Customization template should be downloaded and uploaded via your Primo Admin"
                                        ],
                                        "f6": [
                                            "2019"
                                        ],
                                        "c4": [
                                            "2019"
                                        ],
                                        "f7": [
                                            "Customization template should be downloaded and uploaded via your Primo Admin"
                                        ],
                                        "c5": [
                                            "987654321001021"
                                        ],
                                        "f8": [
                                            "mnu"
                                        ],
                                        "f9": [
                                            "version"
                                        ],
                                        "t": [
                                            1
                                        ],
                                        "f10": [
                                            "ExLibris Primo"
                                        ],
                                        "f20": [
                                            "987654321001021"
                                        ],
                                        "f11": [
                                            "It ain't over... till you download"
                                        ],
                                        "f5": [
                                            "example"
                                        ]
                                    },
                                    "facets": {
                                        "frbrtype": [
                                            "6"
                                        ],
                                        "creatorcontrib": [
                                            "It ain't over... till you download"
                                        ],
                                        "creationdate": [
                                            "2019"
                                        ],
                                        "newrecords": [
                                            "20190107_529"
                                        ],
                                        "library": [
                                            "OTHER"
                                        ],
                                        "atoz": [
                                            "S"
                                        ],
                                        "frbrgroupid": [
                                            "3333333"
                                        ],
                                        "rsrctype": [
                                            "books"
                                        ],
                                        "language": [
                                            "eng"
                                        ],
                                        "prefilter": [
                                            "books"
                                        ]
                                    },
                                    "browse": {
                                        "institution": [
                                            "INST"
                                        ],
                                        "author": [
                                            "$$DIt ain't over... till you download$$EIt ain't over... till you download"
                                        ],
                                        "callnumber": [
                                            "$$IINST$$DOther Call Number$$EOther Call Number$$T0"
                                        ],
                                        "title": [
                                            "$$DExample$$EExample"
                                        ]
                                    }
                                },
                                "@id": "",
                                "beaconO22": "96"
                            }];
                    }
                }
                this.fullViewLoaded = true;
            });
        }
        else{
            this.fullViewLoaded = true;
        }

    }
    public handleEmailTemplate(){
        this.$timeout(() => {
            if(document.querySelector('#email-template-items') && !this.isStudioExample()){ // if we are in OTB tempalte
                this.tmpItems = this.items.slice();
                this.records = '';
                this.intervalCounter = 0;
                // to improve performance, we want to render one item each time, save it aside and attach it to the final template.
                // loading large dataset to the dom at once will lag the UI.
                this.pushItem(); 
            }else{
                this.sendEmailService.templateRenderingInProgress = false;
                this.delayedItems = this.items;
            }
        },0);
    }

    private pushItem(){
        this.delayedItems.push(this.tmpItems.shift());
    }

    public popItem(){
        if(!this.isStudioExample()){
             let counter = 0;
                this.$timeout(() => {
                        this.getRecord(counter);   
                },msTimeout);
            }
    }

    public getRecord(counter: number) {
        if (counter > maxTimeout ) {
            this.missingItemInEmail = true;
            return;
        }
        if (document.querySelector('#email-template-items prm-brief-result prm-highlight') != null) {
            this.records += document.querySelector('#email-template-items').innerHTML;
            this.delayedItems.pop();
            this.intervalCounter += 1;
            if (this.intervalCounter === this.items.length) {
                this.emailTemplateItemsEvent.emit(this.records);
                return;
            } else if (this.intervalCounter < this.items.length) {
                this.pushItem();
            }
            return;
        }
        this.$timeout(() => {
            this.getRecord(counter++);   
        },msTimeout);
    }
	
    private isStudioExample(): boolean{
        return !!this.$location.search()['dirName'];
    }

    public get missingItemInEmail(): boolean {
        return this._missingItemInEmail;
    }
    public set missingItemInEmail(value: boolean) {
        this._missingItemInEmail = value;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/emailTemplate/emailTemplate.directive.ts